export default ({ savedItems: { confirmationType } }) => confirmationType;
